























import Vue, { PropType } from 'vue'

import {ICheckBoxesAgrupados} from 'src/tipos/CheckBoxesAgrupados'
import {resgatarListaDeChavesDosCheckBoxesAgrupados} from 'src/typescript/common/CheckBoxes/utils'

interface Props {
  value: string[];
  opcoes: ICheckBoxesAgrupados;
  direcao: string;
  desativado?: boolean;
  legenda?: string;
}

interface Computed {
  itensInternos: ICheckBoxesAgrupados;
  classesDoGrupo: Record<string, boolean>;
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: 'CheckBoxesAgrupados',

  props: {
    value: {
      type: Array as PropType<string[]>,
      required: true
    },
    opcoes: {
      type: Object as PropType<ICheckBoxesAgrupados>,
      required: true
    },
    direcao: {
      type: String as PropType<'horizontal' | 'vertical'>,
      required: false,
      default: 'vertical',
      validator: (prop: string): boolean => [
        'horizontal',
        'vertical'
      ].includes(prop)
    },
    legenda: {
      type: String,
      required: false
    },
    desativado: {
      type: Boolean,
      required: false
    }
  },

  computed: {
    itensInternos (): ICheckBoxesAgrupados {
      return this.opcoes
    },
    classesDoGrupo (): Record<string, boolean> {
      const {direcao} = this
      return {
        [`check-boxes-agrupados__grupo--${direcao}`]: true
      }
    }
  },

  watch: {
    itensInternos: {
      deep: true,
      handler (opcoes: ICheckBoxesAgrupados): void {
        const listaDeChavesMarcadas = resgatarListaDeChavesDosCheckBoxesAgrupados(opcoes)
        this.$emit('input', listaDeChavesMarcadas)
      }
    }
  }
})
